import { PublicClientApplication } from "@azure/msal-browser";

const tenantId = process.env.REACT_APP_AZURE_TENANT_ID;
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID;

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || `${window.location.origin}/login`,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

export const msalInstance = new PublicClientApplication(msalConfig);
